export default __webpack_public_path__ + "static/media/logo_dadep_eslogan.80c3ab6d.svg";